import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-performance-finishes',
  templateUrl: './performance-finishes.component.html',
  styleUrls: ['./performance-finishes.component.css']
})
export class PerformanceFinishesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
